"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var event_1 = require("./event");

var checkpoint_1 = require("./checkpoint");

var AppForeground =
/** @class */
function (_super) {
  __extends(AppForeground, _super);

  function AppForeground() {
    var _this = this;

    var checkpointEvent = checkpoint_1.default.End("dive_background_checkpoint");

    if (!checkpointEvent) {
      throw new Error("An error occurred while trying to instantiate the appForeground event. This may be because an instance of the appBackground event was not created before.");
    }

    var totalSeconds = checkpointEvent.getEventBody().getJson().total_milliseconds / 1000;
    _this = _super.call(this, "appForeground", {
      id: checkpointEvent.getUuid(),
      total_seconds: Math.round(totalSeconds * 100) / 100
    }) || this;
    return _this;
  }

  AppForeground.prototype._isPrefab = function () {
    return true;
  };

  return AppForeground;
}(event_1.default);

exports.default = AppForeground;